import React from 'react';
import { Navigate } from 'react-router-dom';
import { authApi } from '../api';

const ProtectedRoute = ({ children }) => {
  if (!authApi.isAuthenticated()) {
    return <Navigate to="/sign-in" replace />;
  }

  return children;
};

export default ProtectedRoute; 